export default __webpack_public_path__ + "static/image23-4bb650829575ac55f5fe67d9414cf251.gif";